var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M23.25 28.5L12.75 18L23.25 7.5","stroke":"#656A81","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }